import { IListener, injectDataCache, injectSubject } from '@aesop-fables/scrinium';
import type { DataCache } from '@aesop-fables/scrinium';
import { Observable, Subscription, distinctUntilChanged } from 'rxjs';
import { Predicates } from '../../../predicates/Types';
import { SubscriptionCompartments, subscriptionStorageKey } from '..';

export class SubscriptionListener implements IListener {
  private initialized = false;
  constructor(
    @injectSubject(Predicates.OrganizationSelected)
    private readonly predicate: Observable<boolean>,
    @injectDataCache(subscriptionStorageKey)
    private readonly cache: DataCache<SubscriptionCompartments>,
  ) {}

  start(): Subscription {
    return this.predicate.pipe(distinctUntilChanged()).subscribe(x => {
      if (this.initialized) {
        if (x) {
          this.cache.reload('subscription');
        } else {
          this.cache.reset('subscription');
        }
      } else if (x) {
        this.initialized = true;
      }
    });
  }
}
